export function orgFilePathPrefix(organizationId: string): string {
  return `orgs/${organizationId}/files/`;
}

export function blobPathnameForFile(
  organizationId: string,
  parentType: string,
  targetId: string,
  fileId: string,
  filename: string
): string {
  const safeName = normalizeFilename(filename)
    .replace(/[^a-zA-Z0-9._-]+/g, '_')
    .slice(0, 180);
  return `${orgFilePathPrefix(organizationId)}${parentType}/${targetId}/${fileId}/${safeName || 'file'}`;
}

export function normalizeFilename(filename: string): string {
  return (
    filename
      .trim()
      .replace(/[\u0000-\u001f\u007f]/g, '')
      .slice(0, 200) || 'file'
  );
}

export function pathnameBelongsToOrg(
  pathname: string,
  organizationId: string
): boolean {
  return pathname.startsWith(orgFilePathPrefix(organizationId));
}

export function fileDeliveryUrl(fileId: string): string {
  return `/api/files/${encodeURIComponent(fileId)}`;
}
